import { Image, Text, View } from "@react-pdf/renderer";

import { getZadovoljenaKontrola } from "../../../helpers/GetRecordPointClass";
import { styles } from "../../Tables";

interface TableTemperaturaOgranicenaHeaderProps {
  title1: string;
  value1?: number;
  title2: string;
  value2?: number;
  title3: string;
  value3?: number;
}

export const TableTemperaturaKKTProizvodiListaEvidencijaHeader: React.FC<
  TableTemperaturaOgranicenaHeaderProps
> = ({ title1, value1, title2, value2, title3, value3 }) => (
  <View style={styles.table}>
    {value1 && (
      <View style={styles.tableRow}>
        <View style={styles.tableColHorizontal}>
          <Text>{title1}</Text>
        </View>
        <View style={styles.tableColHorizontal}>
          <Text>{value1}</Text>
        </View>
      </View>
    )}
    {value2 && (
      <View style={styles.tableRow}>
        <View style={styles.tableColHorizontal}>
          <Text>{title2}</Text>
        </View>
        <View style={styles.tableColHorizontal}>
          <Text>{value2}</Text>
        </View>
      </View>
    )}
    {value3 && (
      <View style={styles.tableRow}>
        <View style={styles.tableColHorizontal}>
          <Text>{title3}</Text>
        </View>
        <View style={styles.tableColHorizontal}>
          <Text>{value3}</Text>
        </View>
      </View>
    )}
  </View>
);

export const TableRowTemperaturaKKTProizvodiEvdListaEvidencijaHeader: React.FC<{
  resocitanaTemperatura: string;
  reszadovoljenaKontrola: string;
  restackaPrimjene: string;
  resdatum: string;
  resfullname: string;
  respotpis: string;
  resnapomena: string;
  reskorektivnaMjera: string;
  resproizvod: string;
}> = ({
  resocitanaTemperatura,
  reszadovoljenaKontrola,
  respotpis,
  resnapomena,
  restackaPrimjene,
  resdatum,
  resfullname,
  reskorektivnaMjera,
  resproizvod,
}) => (
  <View style={styles.tableRow}>
    <View style={styles.tableCol}>
      <Text>{restackaPrimjene}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{resproizvod}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{resdatum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{resfullname}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{respotpis}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{resocitanaTemperatura}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{reszadovoljenaKontrola}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{reskorektivnaMjera}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{resnapomena}</Text>
    </View>
  </View>
);

export const TableRowTemperaturaKKTProizvodiEvdListaEvidencija: React.FC<{
  fullname: string;
  potpis: string;
  ocitanaTemperatura: number | null;
  dozvoljenaTempMin: number | null;
  dozvoljenaTempMax: number | null;
  dozvoljenoOdstupanje: number | null;
  datum: string;
  napomena: string;
  tackaPrimjene: string;
  resda: string;
  resne: string;
  korektivnaMjera: boolean;
  proizvod: string;
}> = ({
  fullname,
  potpis,
  ocitanaTemperatura,
  napomena,
  datum,
  dozvoljenaTempMin,
  dozvoljenoOdstupanje,
  dozvoljenaTempMax,
  tackaPrimjene,
  resda,
  resne,
  korektivnaMjera,
  proizvod,
}) => (
  <View style={styles.tableRow} wrap={false}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{tackaPrimjene}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{proizvod}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{fullname}</Text>
    </View>
    <View style={styles.tableCol}>
      {potpis && (
        <Image style={[styles.tableCell, styles.signatureImage]} src={potpis} />
      )}
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{ocitanaTemperatura}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>
        {getZadovoljenaKontrola(
          Number(ocitanaTemperatura),
          dozvoljenaTempMin,
          dozvoljenaTempMax,
          dozvoljenoOdstupanje
        ) === true
          ? resda
          : resne}
      </Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>
        {korektivnaMjera === true ? resda : resne}
      </Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{napomena}</Text>
    </View>
  </View>
);
